import React, { Component } from 'react'
import { axiosPost } from '../../Utils/RequestUtil'
import { Select, Spin, Row, Col } from 'antd'
import update from 'immutability-helper'

const { Option } = Select

export default class CascaderMobile extends Component {
    constructor(props) {
        super(props)
        this.state = {
            answer: this.props.answer === undefined ? '' : this.props.answer,
            index: this.props.index,
            data: this.props.data,
            desc: this.props.data.desc,
            levels: this.props.data.levels,
            require: this.props.data.require,
            renderData: [],
            loading: false,
            isWrite: this.props.isWrite
        }
    }

    componentDidMount() {
        if (this.props.answer !== '') {
            this.getWriteAnswer(this.props.answer)
        } else {
            this.getCascader()
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ isWrite: nextProps.isWrite })
        if (this.props.answer !== '') {
            this.getWriteAnswer(nextProps.answer)
        } else {
            this.getCascader()
        }
    }

    getWriteAnswer = (e) => {
        const levels = this.props.data.levels
        const data = this.props.data
        const selecteds = e.split(',')

        const params = {
            flag: data.flag,
            parent: data.startId
        }
        this.setState({
            loading: true
        })
        axiosPost(14, params, 'Data', (res) => {
            this.setState({
                loading: false
            })
            if (res.code === 0) {
                let newRenderData = []
                for (let i = 0; i < levels.length; i++) {
                    const newData = update(levels[i], { options: { $set: i === 0 ? res.data.list : [] } })
                    const newData2 = update(newData, { selected: { $set: selecteds[i] } })
                    newRenderData.push(newData2)
                }
                for (let j = 0; j < selecteds.length - 1; j++) {
                    const params1 = {
                        flag: data.flag,
                        parent: selecteds[j]
                    }
                    this.setState({
                        loading: true
                    })
                    axiosPost(14, params1, 'Data', (res) => {
                        this.setState({
                            loading: false
                        })
                        if (res.code === 0) {
                            newRenderData[j + 1].options = res.data.list
                        }
                        let hasOptions = true
                        for (let k = 0; k < newRenderData.length; k++) {
                            if (newRenderData[k].options.length === 0) {
                                hasOptions = false
                            }
                        }
                        if (hasOptions) {
                            this.setState({
                                renderData: newRenderData
                            })
                        }
                    })
                }
            }
        })
    }

    getCascader = () => {
        const levels = this.props.data.levels
        const data = this.props.data
        const params = {
            flag: data.flag,
            parent: data.startId
        }
        this.setState({
            loading: true
        })
        axiosPost(14, params, 'Data', (res) => {
            this.setState({
                loading: false
            })
            let newRenderData = []
            if (res.code === 0) {
                for (let i = 0; i < levels.length; i++) {
                    const newData = update(levels[i], { options: { $set: i === 0 ? res.data.list : [] } })
                    const newData2 = update(newData, { selected: { $set: '' } })
                    newRenderData.push(newData2)
                }
                this.setState({
                    renderData: newRenderData
                })
            }
        })
    }

    selectChange = (e, index) => {
        const { renderData, data } = this.state
        if (index + 1 < renderData.length) {
            const params = {
                flag: data.flag,
                parent: e
            }
            this.setState({
                loading: true
            })
            axiosPost(14, params, 'Data', (res) => {
                this.setState({
                    loading: false
                })
                let newData = []
                for (let i = 0; i < renderData.length; i++) {
                    if (i > index) {
                        const newData1 = update(renderData[i], { options: { $set: [] } })
                        const newData2 = update(newData1, { selected: { $set: '' } })
                        newData.push(newData2)
                    } else {
                        newData.push(renderData[i])
                    }
                }
                const newData1 = update(newData[index], { selected: { $set: e } })
                const newData2 = update(newData[index + 1], { options: { $set: res.data.list } })
                const newRenderData = update(newData, { $splice: [[index, 1, newData1], [index + 1, 1, newData2]] })
                this.setState({
                    renderData: newRenderData
                }, () => this.dataUpload())
            })
        } else {
            const newData = update(renderData[index], { selected: { $set: e } })
            const newData1 = update(renderData, { $splice: [[index, 1, newData]] })
            this.setState({
                renderData: newData1
            }, () => this.dataUpload())
        }
    }

    dataUpload = () => {
        const { renderData, index } = this.state
        let answer = ''
        for (let i = 0; i < renderData.length; i++) {
            if (i !== renderData.length - 1) {
                answer += renderData[i].selected + ','
            } else {
                answer += renderData[i].selected
            }
        }
        const data = {
            key: this.state.data.key,
            type: this.state.data.type,
            answer: answer
        }
        this.props.getItemAnswer(data, index)
    }

    render() {
        const { desc, renderData, require, isWrite } = this.state
        return (
            <div>
                <Spin spinning={this.state.loading}>
                    <Row gutter={0} style={{ paddingTop: '5px', paddingBottom: '5px', backgroundColor: '#fff' }} >
                        <Col span={6} style={{ backgroundColor: '#fff', fontSize: '18px', paddingLeft: '15px', color: '#000', lineHeight: '30px' }}>
                            <span style={{ color: 'red', display: require === '1' ? 'inline-block' : 'none', marginRight: '5px' }}>*</span>
                            <span style={{ fontSize: '14px' }}>{desc}</span>
                        </Col>
                        {renderData.map((item, index) => <Col span={6} key={item.level} style={{ backgroundColor: '#fff', paddingRight: '3px' }}>
                            <Select disabled={!isWrite} size='middle' style={{ width: '100%' }} value={item.selected} onChange={(e) => this.selectChange(e, index)}>
                                {item.options.map(option => <Option key={option.id} value={option.id}>{option.desc}</Option>)}
                            </Select>
                        </Col>)}
                    </Row>
                </Spin>
            </div>
        )
    }
}